import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { hasStaffRole } from '@hcc/types';
import { useCurrentUser } from '../../hooks/useAuth';

/**
 * Defence-in-depth wrapper for staff-only routes. The backend enforces
 * the real check (requireStaff on the API); this stops an inductee
 * who types a URL directly from landing on a broken/empty staff page
 * before the API rejects every fetch.
 *
 *   - Loading session → render nothing (fast, no flash).
 *   - No session → bounce to /login.
 *   - Inductee-only session → bounce to /me (their own surface).
 *   - Staff session → render children.
 */
export function RequireStaff({ children }: { children: ReactNode }) {
  const { data: user, isLoading } = useCurrentUser();
  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!hasStaffRole(user.roles)) return <Navigate to="/me" replace />;
  return <>{children}</>;
}
